<!--
BEDROCK Core
Copyright (c) 2026 Patrick Schimmelpfennig

All rights reserved.

Unauthorized copying, modification, distribution or use of this software,
in whole or in part, is strictly prohibited without explicit written permission
from the author or an authorized BEDROCK license grant.
-->

<!Copyright (c) 2026 Patrick Schimmelpfennig

All rights reserved.

Unauthorized copying, modification, distribution or use of this software,
in whole or in part, is strictly prohibited without explicit written permission
from the author or an authorized BEDROCK license grant.
-->

<!Copyright (c) 2026 Patrick Schimmelpfennig

All rights reserved.

Unauthorized copying, modification, distribution or use of this software,
in whole or in part, is strictly prohibited without explicit written permission
from the author or an authorized BEDROCK license grant.
-->

<script setup>
import { computed } from "vue";

const props = defineProps({
    name: { type: String, required: true },
    size: { type: [Number, String], default: 24 },
    color: { type: String, default: "default" },
    border: { type: Boolean, default: false }
});
/*
Load all icons
*/
const modules = import.meta.glob(
    "@/presentation/icons/**/*.svg",
    { eager: true, import: "default" }
);

/*
Build lookup map
*/
const icons = Object.fromEntries(
    Object.entries(modules).map(([path, mod]) => {
        const name = path.split("/").pop().replace(".svg", "");
        return [name, mod];
    })
);

/*
Resolve icon
*/
const iconComponent = computed(() => icons[props.name] ?? null);
</script>

<template>
    <component :is="iconComponent" class="sdev-icon">

    </component>
</template>